import { Section, Container, ExtraLink, SeparatorImageOnlyRoot, HrDouble } from "./styles";
import { LinkAbsolute } from "@/shared/LinkAbsolute";
import ContentPayWallExclusive from "@/shared/ContentPayWallExclusive";
import SeparatorSkeleton from "./SeparatorSkeleton";
import { isValidSponsorImage, useSeparatorBannerImage } from "./helpers";
import Banner from "@/widgets/Banner/Templates/Banner";

const Separator = ({
  link,
  title,
  sectionClass = "",
  tag = "h2",
  extras = [],
  target = "_self",
  titleTarget,
  linkImageMobile,
  linkImageDesktop,
  linkImageDark,
  background,
  color,
  titleEnabled = true,
  imageOnlyClassName = "",
  bannertitle = "",
  isPreview = false,
}) => {
  const linkTarget = titleTarget ?? target;

  const hasTitle = Boolean(title?.trim());
  const hasImage = isValidSponsorImage(linkImageMobile) || isValidSponsorImage(linkImageDesktop)|| isValidSponsorImage(linkImageDark);
  const hasSponsor = hasImage || isValidSponsorImage(linkImageDark);
  const isImageOnly = !hasTitle && hasImage;

  const { imageSrc, showSkeleton, skeletonColor } = useSeparatorBannerImage({
    linkImageDesktop,
    linkImageMobile,
    linkImageDark,
  });


  // Early returns primero, antes de cualquier otra cosa
  if (!titleEnabled || (!hasTitle && !hasSponsor)) return null;

  const titleId = title
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();

  const wrapWithLink = (content, ariaLabel) =>
    link ? (
      <a suppressHydrationWarning href={link} target={linkTarget} aria-label={ariaLabel}>
        {content}
      </a>
    ) : content;

  // Caso especial: solo imagen, sin texto
  if (isImageOnly) {
    const pending = showSkeleton || !imageSrc;
    return (
      <>
       <HrDouble />
      <SeparatorImageOnlyRoot className={imageOnlyClassName?.trim() || "separator-image-only"}>
        {wrapWithLink(
          <div style={{ position: "relative", minHeight: "44px" }}>
            {pending && <SeparatorSkeleton height="44px" color={skeletonColor} absolute />}
            <img
              suppressHydrationWarning
              src={imageSrc ?? ""}
              alt=""
              style={{ opacity: pending ? 0 : 1, transition: "opacity 180ms ease" }}
            />
          </div>,
          "Imagen del separador"
        )}
      </SeparatorImageOnlyRoot>
      </>
    );
  }

  // Caso normal: con título
  const isSpecialSection = sectionClass === "mundialClubes-separator" || sectionClass === "especial-separator";
  const className = [
    sectionClass,
    !hasSponsor && "no-sponsor",
    (link || (sectionClass === "apertura-content" && !hasSponsor)) && "highlighted-title",
    link && "with-link", 
    hasTitle && hasSponsor && !isSpecialSection && "title-with-sponsor",
  ].filter(Boolean).join(" ");
  
  
  const sponsorPending = hasSponsor && (showSkeleton || !imageSrc);
  const DynamicTag = tag;

  return (
    <>
    <Container id={titleId} className={sectionClass} style={background ? { backgroundColor: background } : {}}>
      {!(sectionClass === "apertura-content" && !hasSponsor) && <HrDouble />}
      <Section className={className}>
      {sponsorPending && (
        <SeparatorSkeleton
          height="50px"
          color={skeletonColor}
          absolute
        />
      )}
        <div className="left" style={{ paddingLeft: background ? "25px" : "0", visibility: sponsorPending ? "hidden" : "visible" }}>
          {sectionClass === "suscriptor-content back" && (
            <ContentPayWallExclusive style={{ paddingRight: background ? "5px" : "0" }} />
          )}
          <div className="mt-s" style={{ position: "relative" }}>
            {link && <LinkAbsolute suppressHydrationWarning href={link} target={linkTarget} aria-label={title} />}
            <DynamicTag className="sep" aria-hidden="true" style={color ? { color } : undefined}>
              {title}
            </DynamicTag>
          </div>

          {extras.length > 0 && (
            <ExtraLink className="dd">
              {(!sectionClass || sectionClass === "mundialClubes-separator") &&
                extras.map((element, index) => (
                  <li
                    key={`extras${index}`}
                    className={sectionClass === "mundialClubes-separator" ? "mundialClubes-separator" : ""}
                    style={{ border: `1px solid ${color}` }}
                  >
                    <a suppressHydrationWarning href={element.link} style={color ? { color } : undefined}>
                      {element.title}
                    </a>
                  </li>
                ))}
            </ExtraLink>
          )}
        </div>

        <div className="sponsorHead" style={{ position: "relative", minHeight: "50px", visibility: sponsorPending ? "hidden" : "visible" }}>
          {bannertitle && (<><span id="bannerTitle">Presenta</span> <Banner slotId={bannertitle} isPreview={isPreview} /></>)}
          {imageSrc && (
            <img
              suppressHydrationWarning
              width="300"
              height="50"
              alt="sponsor"
              src={imageSrc}
              style={{ opacity: sponsorPending ? 0 : 1, transition: "opacity 180ms ease" }}
            />
          )}
        </div>
      </Section>
    </Container>
    </>
  );
};

export default Separator;